import { DecimalPipe } from '@angular/common';
import { Component, effect, inject, input } from '@angular/core';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { AccordionModule } from 'primeng/accordion';
import { Button } from 'primeng/button';
import { TooltipModule } from 'primeng/tooltip';
import { KpisGroup } from 'src/app/models/KpisGroup';
import { UtilsService } from 'src/app/utils/utils.service';

@Component({
    selector: 'app-innovation-kpis',
    standalone: true,
    imports: [
        TranslateModule,
        Button,
        TooltipModule,
        AccordionModule,
        DecimalPipe
    ],
    templateUrl: './innovation-kpis.component.html',
    styleUrls: ['./innovation-kpis.component.scss']
})
export class InnovationKpisComponent {
    private readonly utilsService = inject(UtilsService);
    private readonly translateService = inject(TranslateService);

    protected readonly scoreKey = 'KPI.KEY.score';

    protected readonly scoreRatingCells: { label: string; minScore: number }[] = [
        { label: 'VERY_LOW', minScore: 0 },
        { label: 'LOW', minScore: 262 },
        { label: 'GOOD', minScore: 345 },
        { label: 'VERY_GOOD', minScore: 481 },
        { label: 'EXCEPTIONAL', minScore: 510 }
    ];

    protected activedAccordionItems: number[] = [];

    kpis = input.required<KpisGroup[]>();

    constructor() {
        effect(() => {
            if (this.kpis().length > 0) this.expandAll();
        });
    }

    protected translate(value: any): string {
        if (!value && value !== false) return '';

        if (typeof value === 'boolean') {
            return this.utilsService.translateBoolean(value);
        } else if (typeof value === 'string') {
            return this.translateService.instant(value);
        }

        return value;
    }

    protected isNumber(value: any): boolean {
	    return typeof value === 'number';
    }

    protected expandAll(): void {
        this.activedAccordionItems = this.kpis().map((_, index) => index);
    }

    protected colapseAll(): void {
        this.activedAccordionItems = [];
    }

    protected getRatingCellClasses(score: number, cellLabel: string): string {
        const labelClass = cellLabel.toLowerCase().replace(/_/g, '-');
        const isActive = this.getRatingLabel(score) === cellLabel;
        return `rating-cell ${labelClass}${isActive ? '' : ' opacity-30'}`;
    }

    private getRatingLabel(score: number): string {
        if (score >= 510) return 'EXCEPTIONAL';
        if (score >= 481) return 'VERY_GOOD';
        if (score >= 345) return 'GOOD';
        if (score >= 262) return 'LOW';
        return 'VERY_LOW';
    }
}
